import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { Size } from '../../types/size'

type IconProps = {
    isActive: boolean
}

const Icon = styled.svg<IconProps>`
    position: absolute;
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    ${props =>
        !props.isActive &&
        css`
            opacity: 0;
            transform: rotate(${props.rotate});
        `};
`

type MenuProps = {
    size: Size
    isActive: boolean
}

const Menu = ({ size, isActive }: MenuProps) => (
    <Fragment>
        <Icon
            isActive={!isActive}
            rotate={'-90deg'}
            width={size.width}
            height={size.height}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h39v39H0z" />
                <path d="M12 12h-1v-2h19v2H12zm-4 9H7v-2h23v2H8zm4 8h-1v-2h19v2H12z" fill="#0CF" />
            </g>
        </Icon>
        <Icon
            isActive={isActive}
            rotate={'90deg'}
            width={size.width}
            height={size.height}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h39v39H0z" />
                <path
                    fill="#0CF"
                    d="M10.858 12.272l15.87 15.87.756.756 1.414-1.414-.756-.756-15.87-15.87-.756-.756-1.414 1.414z"
                />
                <path
                    fill="#0CF"
                    d="M28.142 12.272l-15.87 15.87-.756.756-1.414-1.414.756-.756 15.87-15.87.756-.756 1.414 1.414z"
                />
            </g>
        </Icon>
    </Fragment>
)

Menu.defaultProps = {
    size: {
        width: 35,
        height: 35,
    },
}

export default Menu
